import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { axiosPrivate } from 'app/utils';

interface SignatureResponse {
  userId: string;
  expiresAt: number;
  signature: string;
}

function generateSignature(): Promise<SignatureResponse> {
  return axiosPrivate.post<SignatureResponse>('/v3/auth/signatures').then((r) => r.data);
}

export function useGenerateSignature({ enabled = true } = {}): UseQueryResult<SignatureResponse> {
  return useQuery({
    queryKey: ['preview-signature'],
    queryFn: generateSignature,
    enabled,
    staleTime: 4 * 60 * 1000, // refresh before the 5min TTL expires
    refetchInterval: 4 * 60 * 1000,
    meta: { errorMessage: 'Failed to generate preview signature' },
  });
}
